export default {
  "pl": {
    "question": {
      "actions": {
        "addDocuments": "Dodaj dokumenty",
        "cancel": "Anuluj",
        "createQuestion": "Utwórz pytanie",
        "delete": "Usuń pytanie",
        "deleteDocuments": "Usuń dokumenty",
        "edit": "Edytuj",
        "new": "Nowe pytanie",
        "save": "Zapisz"
      },
      "attributes": {
        "answer": "Odpowiedź",
        "documents": "Dokumenty/obrazy",
        "name": "Pytanie",
        "question": "Pytanie"
      },
      "labels": {
        "editQuestion": "Edytuj pytanie",
        "newQuestion": "Nowe pytanie"
      },
      "toasts": {
        "create": "Utworzono pytanie",
        "delete": "Usunięto pytanie",
        "update": "Zaktualizowano pytanie"
      },
      "validation": {
        "needAnswer": "Należy podać odpowiedź",
        "needQuestion": "Należy podać pytanie"
      }
    }
  }
}
